<template>
  <div class="flex flex-row gap-3">
    <div
      @click="handleClickTab('report_summary')"
      :class="[
        'p-2  rounded shadow flex-1 flex justify-center items-center cursor-pointer ',
        {
          'bg-white hover:bg-untitled-gray-50 text-untitled-gray-600 ':
            selectedRightSectionTab !== 'report_summary' && !kintzApp,
          'bg-untitled-gray-200 hover:bg-untitled-gray-50 text-untitled-gray-600 ':
            selectedRightSectionTab === 'report_summary' && !kintzApp,
          'bg-kintz-primary-3 hover:bg-kintz-primary-1 text-kintz-primary-4 hover:text-kintz-primary-2':
            selectedRightSectionTab !== 'report_summary' && kintzApp,
          'bg-kintz-primary-1 text-kintz-primary-2':
            selectedRightSectionTab === 'report_summary' && kintzApp,
        },
      ]"
    >
      <p class="text-xs font-medium uppercase text-center">Report Summary</p>
    </div>
    <div
      @click="handleClickTab('my_videos')"
      :class="[
        'p-2  rounded shadow flex-1 flex justify-center items-center cursor-pointer',
        {
          'bg-white hover:bg-untitled-gray-50 text-untitled-gray-600 ':
            selectedRightSectionTab !== 'my_videos' && !kintzApp,
          'bg-untitled-gray-200 hover:bg-untitled-gray-50 text-untitled-gray-600 ':
            selectedRightSectionTab === 'my_videos' && !kintzApp,
          'bg-kintz-primary-3 hover:bg-kintz-primary-1 text-kintz-primary-4 hover:text-kintz-primary-2':
            selectedRightSectionTab !== 'my_videos' && kintzApp,
          'bg-kintz-primary-1 text-kintz-primary-2':
            selectedRightSectionTab === 'my_videos' && kintzApp,
        },
      ]"
    >
      <p class="text-xs font-medium uppercase text-center">My Videos</p>
    </div>
    <div
      @click="handleClickTab('events_and_reminders')"
      :class="[
        'p-2  rounded shadow flex-1 flex justify-center items-center cursor-pointer',
        {
          'bg-white hover:bg-untitled-gray-50 text-untitled-gray-600 ':
            selectedRightSectionTab !== 'events_and_reminders' && !kintzApp,
          'bg-untitled-gray-200 hover:bg-untitled-gray-50 text-untitled-gray-600 ':
            selectedRightSectionTab === 'events_and_reminders' && !kintzApp,
          'bg-kintz-primary-3 hover:bg-kintz-primary-1 text-kintz-primary-4 hover:text-kintz-primary-2':
            selectedRightSectionTab !== 'events_and_reminders' && kintzApp,
          'bg-kintz-primary-1 text-kintz-primary-2':
            selectedRightSectionTab === 'events_and_reminders' && kintzApp,
        },
      ]"
    >
      <p class="text-xs font-medium uppercase text-center">
        Events & Reminders
      </p>
    </div>
  </div>
</template>

<script setup>
import { inject } from "vue";
import { useHomeTabsStore } from "../../../stores/home/useHomeTabs.store";
import { storeToRefs } from "pinia";

const kintzApp = inject("kintz-app", false);

const homeTabStore = useHomeTabsStore();
const { selectedRightSectionTab } = storeToRefs(homeTabStore);

const handleClickTab = (tab) => {
  selectedRightSectionTab.value = tab;
};
</script>

<style lang="scss" scoped></style>
